const PrintType = require('@/lib/Printing/PrintType');

/**
 * @param {PrintRouter} printRouter
 */
const disableSignProPrintRouting = (printRouter) => {
    console.log('Overriding print config to disable Sign Pro.');
    console.log('Original', JSON.stringify(printRouter.typeRoutings));
    printRouter.clearTypeRouting(PrintType.RECEIPT);
    printRouter.clearTypeRouting(PrintType.RECEIPT_DUPLICATE);
    console.log('Modified', JSON.stringify(printRouter.typeRoutings));
};

module.exports = {
    disableSignProPrintRouting,
};
